import React from "react";

const SoundCloudPage = () => {
  return (
    <>
      <div className="salva-soundcloud-video">
        <iframe
          height="450"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/471954807&color=%23ff5500&auto_play=true&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
        ></iframe>
      </div>
    </>
  );
};
export default SoundCloudPage;
